module.exports = __webpack_public_path__ + "img/066-knight.98a3c8c0.png";